import { EmployeeSearchInputKindEnum } from 'src/api';
import type { EmployeeSearchCriteria } from 'src/types/employeeSearch';
import { toIsoDate, toSearchDigits, toSearchText } from 'src/utils/employeeSearch';

import type { IdentitySearchFormValues } from './types';

export const identityValuesToCriteria = (
  values: IdentitySearchFormValues,
): EmployeeSearchCriteria => ({
  kind: EmployeeSearchInputKindEnum.PersonalInfo,
  ssn: toSearchDigits(values.ssn),
  last4Ssn: toSearchDigits(values.last4Ssn),
  firstName: toSearchText(values.firstName),
  lastName: toSearchText(values.lastName),
  birthDate: toIsoDate(values.birthDate),
});

/**
 * Prefills the form from restored criteria. The SSN is never persisted, so it
 * always comes back empty — the restored search ran without it.
 */
export const identityCriteriaToValues = (
  criteria: EmployeeSearchCriteria,
): IdentitySearchFormValues => ({
  ssn: null,
  last4Ssn: criteria.last4Ssn ?? null,
  firstName: criteria.firstName ?? null,
  lastName: criteria.lastName ?? null,
  birthDate: criteria.birthDate ?? null,
});
